angular.module('impactx.MenuDirectives').directive('ixDeactivateThemeWorld', function() {
    return {
        restrict: 'E',
        controller: 'DeactivateThemeWorldCtrl',
        controllerAs: 'deactivateThemeWorldCtrl',
        templateUrl: 'shared/menu/templates/deactivatethemeworld.tmpl.html'
    }
});